import { IPubCenterFonts, IPubcenterSpacing } from '../../../../theme';
import { IReportLandingPageStyleProps, IReportLandingPageStyles } from './LandingPage.types';

export const getStyles = (props: IReportLandingPageStyleProps): IReportLandingPageStyles => {
  const { theme } = props;
  const spacing = theme.spacing as IPubcenterSpacing;
  const fonts = theme.fonts as IPubCenterFonts;

  return {
    root: {
      height: '100%',
      alignItems: 'center',
    },
    title: {
      fontSize: fonts.size28.fontSize,
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: spacing.size20,
    },
    description: {
      fontSize: fonts.size14.fontSize,
      textAlign: 'center',
    },
    sectionTitle: {
      fontWeight: 'bold',
      fontSize: fonts.size14.fontSize,
      textAlign: 'center',
    },
    sectionDescription: {
      fontSize: fonts.size12.fontSize,
      textAlign: 'center',
    },
    sectionsStyle: {
      width: '75%',
    },
    sectionStyle: {
      padding: spacing.size40,
      marginBottom: spacing.size20,
    },
    primaryButton: {
      borderRadius: spacing.size4,
    },
    secondaryButton: {
      borderWidth: spacing.size0,
      borderRadius: spacing.size4,
    },
  };
};
